var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D92128;}\r\n\t.st1{fill:#ED1C24;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_246_",
    className: "st0",
    d: "M27,6h-6V5c0-1.7-1.3-3-3-3h-4c-1.7,0-3,1.3-3,3v1H5C3.9,6,3,6.9,3,8v1c0,0.6,0.4,1,1,1h24 c0.6,0,1-0.4,1-1V8C29,6.9,28.1,6,27,6z M13,5c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v1h-6V5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_249_",
    className: "st1",
    d: "M6,12v15c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3V12H6z M19.7,22.3c0.4,0.4,0.4,1,0,1.4 s-1,0.4-1.4,0L16,21.4l-2.3,2.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l2.3-2.3l-2.3-2.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l2.3,2.3 l2.3-2.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L17.4,20L19.7,22.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/archived.2ba73a18d77b3f442567716962c69f36.svg";
export { ForwardRef as ReactComponent };